/* Accessibility fixes from the manual audit (ADA/2026-09-14-manual-audit-phase2-findings.md), 28 Oct 2026.
   Behaviour only, nothing visible changes:
   - one polite status region for the whole page: "added to cart", filter result counts (M1, M4);
   - the header cart link says how many items are in the cart (M17);
   - Escape closes an open mega menu and returns focus to its trigger (M3);
   - collection filters keep keyboard focus on the box just ticked after the grid reloads (M4);
   - the subscription quiz moves focus to each new step's heading (M7).
   Each part checks the elements it needs and does nothing on pages without them. */
(function () {
  'use strict';

  function status() {
    var el = document.getElementById('A11yStatus');
    if (!el) {
      el = document.createElement('div');
      el.id = 'A11yStatus';
      el.className = 'visually-hidden';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.setAttribute('aria-atomic', 'true');
      document.body.appendChild(el);
    }
    return el;
  }

  function announce(text) {
    var el = status();
    el.textContent = '';
    window.setTimeout(function () { el.textContent = text; }, 60);   // re-announces repeated text
  }

  /* Cart: announce additions and keep the cart link's item count in its name */
  function cartCountText(count) {
    return count > 0 ? ', ' + count + (count === 1 ? ' item' : ' items') : '';
  }
  function syncCartCount() {
    var routes = window.theme && window.theme.routes;
    if (!routes || !routes.cartPage) {
      console.error('A11Y_CART_ROUTES_MISSING: theme.routes.cartPage is not set, cart count not updated');
      return;
    }
    fetch(routes.cartPage + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart.js ' + r.status); return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-a11y-cart-count]').forEach(function (el) { el.textContent = cartCountText(cart.item_count); });
      })
      .catch(function (e) { console.error('A11Y_CART_COUNT_FAILED', e); });
  }
  document.addEventListener('ajaxProduct:added', function (evt) {
    var p = evt.detail && evt.detail.product;
    var name = p && (p.product_title || p.title);
    announce(name ? name + ' added to cart' : 'Added to cart');
    syncCartCount();
  });
  document.addEventListener('cart:updated', syncCartCount);

  /* Mega menu: Escape closes the open panel and puts focus back on its trigger */
  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Escape') return;
    var open = document.querySelector('.cmm--open');
    if (!open) return;
    var trigger = open.querySelector('.cmm__trigger');
    if (!trigger) return;
    trigger.click();   // the menu's own toggle closes it (and the page overlay)
    trigger.focus();
  });

  /* Collection filters: remember the ticked box, refocus it after the grid reloads, announce the count */
  var lastFilter = null;
  document.addEventListener('change', function (evt) {
    var input = evt.target;
    if (!input.matches || !input.matches('.collection-sidebar input, #FilterDrawer input, .filter-form input')) return;
    lastFilter = { name: input.name, value: input.value };
  });
  document.addEventListener('collection:reloaded', function () {
    if (!lastFilter) return;
    var sel = 'input[name="' + CSS.escape(lastFilter.name) + '"][value="' + CSS.escape(lastFilter.value) + '"]';
    var again = document.querySelector('#FilterDrawer.drawer--is-open ' + sel) || document.querySelector(sel);
    if (again && again.offsetParent !== null) again.focus({ preventScroll: true });
    var count = document.querySelector('.collection-filter__item--count');
    if (count && count.textContent.trim()) announce(count.textContent.trim());
    lastFilter = null;
  });

  /* Subscription quiz: when a new step appears, move focus to its heading */
  function initQuiz() {
    var form = document.querySelector('.multi-step-form');
    if (!form) return;
    var obs = new MutationObserver(function (records) {
      records.forEach(function (r) {
        var page = r.target;
        if (!page.classList.contains('active') || (r.oldValue || '').split(' ').indexOf('active') > -1) return;
        var h = page.querySelector('.step-number, h1, h2');
        if (!h) return;
        if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1');
        h.focus();
      });
    });
    form.querySelectorAll('.form-page, .start-page').forEach(function (p) {
      obs.observe(p, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
    });
  }

  function init() { status(); initQuiz(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
